import ModalAdvanceFilter from 'components/commons/modal-advance-filter'
import { Button } from 'avo-ui'
import clsx from 'clsx'
import icFilterWhite from 'assets/images/ic-filter-white.svg'
import icFilter from 'assets/images/ic-filter.svg'
import Select from 'components/commons/select'
import CheckboxList from 'components/commons/checkbox-list'

export const AdvanceFilter = ({
    show,
    setShow,
    filterDetail,
    getFilterCount,
    onChangeForm,
    onClear,
    options,
    onSearchOptions,
    onSubmit,
}) => {
    return (
        <div>
            <div className={'w-fit relative'}>
                <Button
                    className={clsx(getFilterCount() > 0 && '!bg-blue-90 !text-white')}
                    title={'Filter'}
                    icon={getFilterCount() > 0 ? icFilterWhite : icFilter}
                    type={'outline'}
                    onClick={() => setShow(!show)}
                />
                <div
                    className={`absolute -right-1 -top-3.5 py-1 px-2.5 text-white bg-blue-95 rounded-full ${getFilterCount() > 0 ? 'block' : 'hidden'}`}
                >
                    {getFilterCount()}
                </div>
            </div>
            <ModalAdvanceFilter
                className={'!w-[850px]'}
                classNameContent={'!max-h-[500px] overflow-auto'}
                show={show}
                onHide={() => setShow(false)}
                title={'Filter'}
                onClear={onClear}
                onSubmit={() => onSubmit(filterDetail)}
            >
                <div className={'flex space-x-16 px-8 py-2 mb-2'}>
                    <div className={'flex-1 flex-col space-y-5'}>
                        <div className={'flex flex-col space-y-3'}>
                            <div className={'font-semibold text-blue-90'}>Filter by Brand</div>
                            <Select
                                name={'brand_ids'}
                                className={'flex-1'}
                                optionsClassName={'max-h-40'}
                                placeholder={'Pilih brand'}
                                options={options?.brand}
                                value={filterDetail?.brand_ids}
                                searchable
                                isMultiple
                                onChange={onChangeForm}
                                onSearch={(value) => onSearchOptions('brand', value)}
                            />
                        </div>
                        <div className={'flex flex-col space-y-3'}>
                            <div className={'font-semibold text-blue-90'}>Filter by Type Product</div>
                            <Select
                                name={'type_ids'}
                                className={'flex-1'}
                                optionsClassName={'max-h-40'}
                                placeholder={'Pilih Tipe Produk'}
                                options={options?.product_type}
                                value={filterDetail?.type_ids}
                                searchable
                                isMultiple
                                onChange={onChangeForm}
                                onSearch={(value) => onSearchOptions('product_type', value)}
                            />
                        </div>
                    </div>
                    <div className={'flex-1 flex-col space-y-5'}>
                        <div className={'flex flex-col space-y-3'}>
                            <div className={'font-semibold text-blue-90'}>Filter by Category</div>
                            <Select
                                name={'category_ids'}
                                className={'flex-1'}
                                optionsClassName={'max-h-40'}
                                placeholder={'Pilih kategori'}
                                options={options?.category}
                                value={filterDetail?.category_ids}
                                searchable
                                isMultiple
                                onChange={onChangeForm}
                                onSearch={(value) => onSearchOptions('category', value)}
                            />
                        </div>
                        <div className={'flex flex-col space-y-3'}>
                            <div className={'font-semibold text-blue-90'}>Filter by Status</div>
                            <CheckboxList
                                className={'flex-1'}
                                name={'Status'}
                                options={options?.status}
                                values={filterDetail?.status}
                                onChange={(value) => onChangeForm({ name: 'status', value })}
                            />
                        </div>
                    </div>
                </div>
            </ModalAdvanceFilter>
        </div>
    )
}
